import { useEffect, useState } from "react";

import { apiClient } from "../api/client.js";
import { useAuth } from "../auth/AuthContext.js";

export interface VenueOption {
  id: string;
  name: string;
}

export interface VenueOptionsResult {
  options: VenueOption[];
  loaded: boolean;
  error: string | null;
}

/** Venues the caller can see: every venue for platform admins, their fleets' otherwise. */
export function useVenueOptions(): VenueOptionsResult {
  const { user } = useAuth();
  const [options, setOptions] = useState<VenueOption[]>([]);
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!user) {
      return;
    }
    apiClient["/api/v1/admin/venues"]
      ["get"]({ parameters: {}, body: null })
      .then((res) => {
        if (res.code === 200) {
          setOptions(res.body.map((v) => ({ id: v.id, name: v.name })));
        }
      })
      .catch(() => {
        setOptions([]);
        setError("Failed to load venues");
      })
      .finally(() => setLoaded(true));
  }, [user]);

  return { options, loaded, error };
}
